module.exports = "/images/icon_loud02.png?33c1973269ac809ea039d1ee59d1ee52";